import { render, staticRenderFns } from "./bo-point.vue?vue&type=template&id=586daf7b"
import script from "./bo-point.vue?vue&type=script&lang=js"
export * from "./bo-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports